import React, {useEffect, useState} from 'react';
import {Button, Card, Form, Input, InputNumber} from 'antd';
import {useParams} from 'react-router-dom';
import {useNavigate} from 'react-router-dom';
import {
  OnlyAlphabetInputValidator,
  NumberWithDecimalValidation,
  validateString,
  PriceLimitationValidation,
  NumberWithoutDecimalValidation,
  OnlyAlphabetInputValidatorWithSpecialCharacters,
} from '../../../../Util/commonUtility';
import useLocalization from '../../../../Localization';

const AdFeesFormComponent = (props) => {
  
  const [submit, setSubmit] = useState(false);
  const {ApplicationString} = useLocalization();
  const [submitLabel, setSubmitLabel] = useState(
    ApplicationString['common.button.submitForm'],
  );
  const [form] = Form.useForm();
  const {postAdFees, EditData, updateAdFees, fetchAdFeesById} = props;
  let navigate = useNavigate();
  

  useEffect(() => {
    if (id) {
      fetchAdFeesById(id);
      setSubmitLabel(ApplicationString['common.button.updateForm']);
    }
  }, []);

  useEffect(() => {
    if (id) {
      EditData &&
        form.setFieldsValue({
          ...EditData,
        });
    }
  }, [EditData]);

  const backToAdFees = () => {
    navigate('/admin/adfees');
  };

  const onFinish = (values) => {
    const Data = {
      ...values,
      fee: values?.fee ? parseInt(values?.fee) : undefined,
    };
    if (id) {
      updateAdFees(Data, EditData.id);
      // form.resetFields();
    } else {
      postAdFees(Data);
      // form.resetFields();
    }
    setSubmit(true);
  };
  const {id} = useParams();
  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };
  const onReset = () => {
    form.resetFields();
  };

  return (
    <div className='head-main-container'>
      <div className='main-form-container'>
        <Form
          form={form}
          name='basic'
          onFinish={onFinish}
          layout='vertical'
          className='two-column-form'
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          initialValues={''}>
          <div className='input-container'>
            <div className='form-column'>
              <Form.Item
                label='Fee'
                name='fee'
                rules={[
                  {required: true, message: 'Fee should not be empty'},
                  {
                    validator: (_, value) =>
                      NumberWithoutDecimalValidation(value, 'Fee', 9999999),
                  },
                ]}>
                <Input
                  // maxLength={6}
                  prefixCls='common-input-user'
                  className='genral-form'
                  placeholder='Enter fee for ad'
                />
              </Form.Item>
              <Form.Item
                label='Details'
                name='details'
                rules={[
                  {required: true, message: 'Details should not be empty'},
                  {
                    validator: (_, value) =>
                      OnlyAlphabetInputValidatorWithSpecialCharacters(
                        value,
                        'Details',
                      ),
                  },
                ]}>
                <Input
                  prefixCls='common-input-user'
                  className='genral-form'
                  rows={4}
                  placeholder='Enter details for ad fees'
                />
              </Form.Item>
            </div>
          </div>

          <Form.Item>
            <div className='button-container'>
              <Button
                id='adminAdFees-backButton-button'
                className='common-submit-login common-form-submit common-form-cancel'
                onClick={() => {
                  backToAdFees();
                }}>
                {ApplicationString['common.button.backForm']}
              </Button>
              <div className='form-flex-button'>
                <Button
                  id='adminAdFees-submitButton-button'
                  type='primary'
                  htmlType='submit'
                  //disabled={submit ? true : false}
                  className='common-submit-login common-form-submit'>
                  {submitLabel}
                </Button>
                <Button
                  className='common-submit-login common-form-submit common-form-cancel'
                  htmlType='button'
                  id='adminAdFees-resetButton-reset'
                  onClick={onReset}>
                  {ApplicationString['dynamicSearch.button.reset']}
                </Button>{' '}
              </div>
            </div>
          </Form.Item>
        </Form>
      </div>{' '}
    </div>
  );
};

export default AdFeesFormComponent;
